// psychometrist returns avatars as the full-size original:
//   https://host/pic/user.{id}/{id}/{uuid}.png?v={mtime}
// Its PicController resizes on the fly from the name segment
// ({id}w{W}h{H}c1 = W x H cover-crop) and encodes by output extension, then
// caches the result under public/pic, so we ask for exactly what we render.
const PIC_AVATAR_RE = /^(.*\/pic\/user\.(\d+)\/)(\d+)(\/[^/?#]+)\.(?:png|jpe?g|webp|gif|avif)(\?[^#]*)?$/;

// Keep the set of sizes small so every screen shares the same cached variants.
// Values are rendered px x2 for high-DPI screens.
export const AVATAR_SIZE = {
  small: 96, // header button (40px), menu (48px)
  card: 256, // DoctorAvatar: doctor card (64px) and booking modal header (40-56px)
} as const;

/**
 * Rewrites a psychometrist /pic avatar URL to a square, webp variant of the
 * given size. Any other URL (mocks, already-sized, other hosts) is returned
 * unchanged.
 */
export function sizedAvatar(url: string, size: number): string {
  const match = PIC_AVATAR_RE.exec(url);
  if (!match) return url;

  const [, prefix, folderId, nameId, file, query = ""] = match;
  // Only rewrite the plain original; the id in folder and name must agree
  if (folderId !== nameId) return url;

  return `${prefix}${nameId}w${size}h${size}c1${file}.webp${query}`;
}

/**
 * True when next/image should skip its optimizer: /pic variants are already
 * resized + webp-encoded (a second pass only adds latency), and .local hosts
 * aren't reachable from the Next server.
 */
export function isPreSizedAvatar(url: string): boolean {
  return /\/pic\/user\.\d+\//.test(url) || url.includes(".local");
}
